import { useQuery } from "@tanstack/react-query";
import {
	EnrollmentSummaryFilters,
	EnrollmentSummaryResponse,
	reportsService,
} from "../../services/reports.service";

const useEnrollmentSummaryReport = (filters: EnrollmentSummaryFilters) => {
	const enabled = Boolean(filters.accountId && filters.programId);

	return useQuery<EnrollmentSummaryResponse>({
		queryKey: [
			"reports-enrollment-summary",
			filters.accountId,
			filters.programId,
			filters.orgUnitId ?? "",
			filters.researcherId ?? "",
			filters.startDate ?? "",
			filters.endDate ?? "",
			filters.pageNumber ?? 0,
			filters.pageSize ?? 10,
		],
		queryFn: () => reportsService.getEnrollmentSummary(filters),
		enabled,
		staleTime: 1000 * 60 * 5,
	});
};

export default useEnrollmentSummaryReport;
